export const selectHorseById = ({ stable: { horses } }, id) => horses.find((horse) => horse.static.asset.assetName === id);
